import { render, staticRenderFns } from "./TLightButton.vue?vue&type=template&id=0ade7046&"
import script from "./TLightButton.vue?vue&type=script&lang=js&"
export * from "./TLightButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ade7046')) {
      api.createRecord('0ade7046', component.options)
    } else {
      api.reload('0ade7046', component.options)
    }
    module.hot.accept("./TLightButton.vue?vue&type=template&id=0ade7046&", function () {
      api.rerender('0ade7046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/TLightButton.vue"
export default component.exports